import { Component, inject } from "@angular/core";

import { TagModule } from "primeng/tag";

import { VERSION } from "@core/version";
import { AccordionComponent, ButtonComponent } from "@shared/components";
import { GlobalService } from "@shared/services";
import { FeedbackOverlayComponent } from "@home/components/about/components/feedback-overlay/feedback-overlay.component";
import { VersionsComponent } from "@home/components/about/components/versions/versions.component";
import { KnownIssuesComponent } from "@home/components/about/components/known-issues/known-issues.component";

@Component({
  selector: "app-about",
  standalone: true,
  imports: [
    AccordionComponent,
    ButtonComponent,
    FeedbackOverlayComponent,
    TagModule,
    VersionsComponent,
    KnownIssuesComponent,
  ],
  templateUrl: "./about.component.html",
  styleUrl: "./about.component.scss",
})
export class AboutComponent {
  globalService = inject(GlobalService);

  version: string = VERSION;

  feedbackVisible: boolean = false;

  getContentHeight(): string {
    const emulatingOffset = this.globalService.emulatedUser() ? 34 : 0;
    const otherContent = this.globalService.navbarHeight() + emulatingOffset + 335;
    return `calc(100vh - ${otherContent}px)`;
  }
}
